import {gsap} from "gsap";
import {initproductsSectionsEffects} from "../components/productsSectionsEffects";


export function initMainPageLanding() {
    const tabletWidth = 1000;


    function initMainSectionEffects() {
        const mainScreen = $('.main-screen');
        const titleFirstLine =  mainScreen.find('.title').find('.first-line');
        const titleSecondLine =  mainScreen.find('.title').find('.second-line');
        const textFirstLine = mainScreen.find('.text').find('.first-line');
        const textSecondLine = mainScreen.find('.text').find('.second-line');
        const pageLoaded = sessionStorage.getItem('pageLoaded');
        const delay = pageLoaded ? 0.3 : 3.8 ;
        const tl = gsap.timeline();

        tl.from(titleFirstLine, {duration: 0.3, delay: delay, y: '200%', opacity: 0})
            .from(titleSecondLine, {duration: 0.3, y: '100%'}, "-=0.1")
            .from(textFirstLine, {duration: 0.3, y: '200%', opacity: 0}, "-=0.2")
            .from(textSecondLine, {duration: 0.3, y: '100%'}, "-=0.1");
    }

    function initAboutSectionEffects() {
        const aboutSection = $('.about-company');
        const aboutContainer = $('.about-company .container');
        const aboutContent = $('.about-company .content');
        const textContent = $('.about-company .text-content');
        const bgWrapper = $('.about-company .bg-wrapper');
        const gradientBottom = $('.about-company .gradient-bottom');
        let circleAnimationEnd;

        if ($(window).width() > tabletWidth) {
            circleAnimationEnd = () => $(window).height() * 3;

            gsap.timeline({
                scrollTrigger: {
                    trigger: aboutContainer,
                    pin: aboutContent,
                    pinSpacing: true,
                    start: `top top`,
                    end: circleAnimationEnd,
                    invalidateOnRefresh: true,
                }
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: aboutSection,
                    start: 'top+=50 bottom',
                    end: 'bottom bottom',
                    scrub: true,
                    ease: "none",
                    invalidateOnRefresh: true,
                },
            }).fromTo(bgWrapper, {scale: 0.3}, {scale: 1})
              .fromTo(textContent, {y: '100%', opacity: 0, scale: 0}, {y: 0, opacity: 1, scale: 1}, 0)
              .fromTo(bgWrapper, {y: 0}, {y: '-40%'})
              .fromTo(gradientBottom, {y: '30%'}, {y: '-30%'});
        }

        if ($(window).width() <= tabletWidth) {
            circleAnimationEnd = () => $(window).height() * 1.5;

            gsap.timeline({
                scrollTrigger: {
                    trigger: aboutContainer,
                    pin: aboutContent,
                    pinSpacing: true,
                    start: `top top`,
                    end: circleAnimationEnd,
                    invalidateOnRefresh: true,
                }
            });

            gsap.timeline({
                scrollTrigger: {
                    trigger: aboutSection,
                    start: 'top+=15% center',
                    end: 'bottom bottom',
                    scrub: true,
                    ease: "none",
                    invalidateOnRefresh: true,
                },
            }).fromTo(bgWrapper, {scale: 0, y: 0}, {scale: 1, y: '-5%'})
              .fromTo(textContent, {y: 130, opacity: 0, scale: 0}, {y: 0, opacity: 1, scale: 1}, '0')
              .fromTo(bgWrapper, {y: '-5%'}, {y: '-50%'})
        }



    }


    initMainSectionEffects();
    initAboutSectionEffects();
    initproductsSectionsEffects();
}
